// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610070505/js/" + chunkId + "." + {"44":"263b283f","225":"01535d7b","481":"3dde7602","486":"61a87d9d","770":"e7168313"}[chunkId] + ".0.823374129846463.chunk.js";
};